import EditHospital from './EditHospital';

export default EditHospital;
